import { render, staticRenderFns } from "./RegulatorySettings.vue?vue&type=template&id=9b63755e"
import script from "./RegulatorySettings.vue?vue&type=script&lang=ts"
export * from "./RegulatorySettings.vue?vue&type=script&lang=ts"
import style0 from "./RegulatorySettings.vue?vue&type=style&index=0&id=9b63755e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports